// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 课程服务配置列表 GET /vip-config/tj/list */
export async function vipConfigTjListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListVipConfigTjResp>('/vip-config/tj/list', {
    method: 'GET',
    ...(options || {}),
  });
}
